module.exports = ApexCharts;